import { Data } from '../Data';

export class AbsenceDataService {
  constructor() {
    this.dataService = new Data();
  }

  getAbsenceSummary(districtno) {
    const ssnid = this.dataService.getSsnId();
    const url = '/api/absence/summary?ssnid=' + ssnid + '&districtno=' + districtno;
    return this.dataService.performAuthenticatedFetch(url);
  }

  getAbsenceInfo(districtno) {
    const ssnid = this.dataService.getSsnId();
    const url = '/api/absence/info?ssnid=' + ssnid + '&districtno=' + districtno;
    return this.dataService.performAuthenticatedFetch(url);
  }
}